import { createRoot } from "react-dom/client";
import { StrictMode } from "react";

import "./index.css";

import { QueryClientProvider } from "@tanstack/react-query";
import { HeroUIProvider } from "@heroui/react";

import { queryClient } from "./api/queryClient";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HeroUIProvider>
        <App />
      </HeroUIProvider>
    </QueryClientProvider>
  </StrictMode>
);
